module.exports = __webpack_public_path__ + "img/in-it-together.330462aa.png";